import styled from '@emotion/styled';
import { useMediaQuery, useTheme } from '@mui/material';
import { desktopTemplateAnimationVariants } from 'animations/layout/pageTemplateAnimations';
import { motion } from 'framer-motion';
import { useAtom } from 'jotai';
import { isSidebarOpenAtom } from 'store/private/layout/layoutAtoms';

import { Tabs } from '../Tabs';
import { TemplateTitleBar } from './TemplateTitleBar/TemplateTitleBar';

export const PageTemplate = props => {
  const { children } = props;

  const [isSidebarOpen] = useAtom(isSidebarOpenAtom);
  const theme = useTheme();
  const isBelowMd = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Wrapper
      animate={isSidebarOpen ? 'default' : 'wide'}
      variants={desktopTemplateAnimationVariants}
    >
      <TemplateTitleBar />
      {!isBelowMd && <Tabs />}
      <Main>
        <Children>{children}</Children>
      </Main>
    </Wrapper>
  );
};

const Wrapper = styled(motion.section)`
  padding: 0;
  z-index: 10;
  overflow: hidden;
  position: relative;
  top: 0;
  left: 0;
  ${({ theme }) => ({
    height: 'calc(100vh - 16px)',
    backgroundColor: theme.palette.layout.disabled,

    [theme.breakpoints.down('md')]: {
      width: '100% !important',
      backgroundColor: 'white',
    },
  })}
`;

const Main = styled.main`
  width: 100%;
  overflow: hidden;
  overflow-y: auto;
  height: calc(100vh - 97px);
  ${({ theme }) => ({
    backgroundColor: theme.palette.layout.main,

    [theme.breakpoints.down('md')]: {
      width: '100% !important',
      height: 'calc(100vh - 107px)',
      paddingBottom: '30px',
    },
  })}
`;

const Children = styled.div`
  width: 100%;
  height: auto;
  overflow: hidden;
  direction: rtl;
  padding: 16px;
`;
